module.exports = __webpack_public_path__ + "img/background-video-slider-hyundai.eb18095b.jpg";